import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText } from '../style'

const ValidationProposalModal = ({ toggleModal, sections }) => {
  const closeModal = () => {
    toggleModal(false)
  }

  return (
    <div>
      <ValidationProposalModalText>
        Further details are required before you can propose this assessment. Please review and complete the empty fields
        that are mandatory in the following pages: <b> {sections.join(', ')}</b>
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="primary" onClick={closeModal}>
          <FormattedMessage id="continueEditing" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default ValidationProposalModal
